import { effectScope, onScopeDispose, watch } from 'vue'

/**
 * Manages a Vue effect scope that is started and stopped based on a reactive boolean source.
 * When the source becomes true, a new effect scope is started and the provided function is run within it.
 * When the source becomes false, the effect scope is stopped and cleaned up.
 *
 * @param {import('vue').WatchSource<boolean>} source - Reactive source controlling the scope's active state.
 * @param {Function} fn - Function to run inside the effect scope.
 */
export function useToggleScope(source, fn) {
  let scope
  function start() {
    scope = effectScope()
    scope.run(() => fn())
  }

  watch(
    source,
    active => {
      if (active && !scope) {
        start()
      } else if (!active) {
        scope?.stop()
        scope = undefined
      }
    },
    { immediate: true }
  )

  onScopeDispose(() => {
    scope?.stop()
  })
}
